/**
 * ResizeObserver callbacks that read layout and write CSS can retrigger observation
 * in the same frame. Schedule work on the next animation frame to avoid loop errors.
 */
export function scheduleResizeUpdate(callback) {
  if (typeof window === "undefined") {
    callback();
    return () => {};
  }

  let rafId = null;
  const run = () => {
    if (rafId !== null) return;
    rafId = window.requestAnimationFrame(() => {
      rafId = null;
      callback();
    });
  };

  run.cancel = () => {
    if (rafId !== null) {
      window.cancelAnimationFrame(rafId);
      rafId = null;
    }
  };

  return run;
}

export function setStylePropertyIfChanged(el, name, value) {
  if (!el) return;
  if (el.style.getPropertyValue(name) === value) return;
  el.style.setProperty(name, value);
}

export function removeStylePropertyIfSet(el, name) {
  if (!el || !el.style.getPropertyValue(name)) return;
  el.style.removeProperty(name);
}

const RESIZE_OBSERVER_LOOP =
  /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/i;

export function isBenignResizeObserverError(message) {
  if (message == null) return false;
  const text =
    typeof message === "string" ? message : String(message.message || message);
  return RESIZE_OBSERVER_LOOP.test(text);
}

export function suppressBenignResizeObserverErrors() {
  if (typeof window === "undefined" || window.__peerPoetryResizeObserverPatch) {
    return;
  }

  // Main patch runs from public/resize-observer-patch.js before the bundle loads.
  window.__peerPoetryResizeObserverPatch = true;
}
